/** The banner shown while Customize is open (Home spec §4): says how to
 * reorder, that changes save as you go, and offers Reset / Done. */
import { Check } from 'lucide-react'
import { Button } from '@/components/ui'
import { tourAnchor } from '@/components/tour/tourAnchor'

export function HomeCustomizeBar({ onReset, onDone }: { onReset: () => void; onDone: () => void }) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-dashed border-primary bg-primary/5 px-3.5 py-2.5 text-[13px]">
      <span>Drag a card by its handle, or use the arrows. Pick a width. Remove what you do not need and add it back below. Changes are kept as you make them.</span>
      <div className="ml-auto flex gap-2">
        <Button variant="ghost" size="sm" onClick={onReset}>Reset to default</Button>
        <Button size="sm" onClick={onDone} {...tourAnchor('home.customize.done')}><Check className="size-4" /> Done</Button>
      </div>
    </div>
  )
}
